import type { Session, User } from '@supabase/supabase-js';
import { create } from 'zustand';

export type Role = 'owner' | 'admin' | 'attendant' | 'technician' | 'finance';

export interface OrganizationMember {
  organizationId: string;
  role: Role;
  name: string;
}

export interface AuthState {
  session: Session | null;
  user: User | null;
  currentOrg: OrganizationMember | null;
  setSession: (session: Session | null) => void;
  setUser: (user: User | null) => void;
  setCurrentOrg: (org: OrganizationMember | null) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  currentOrg: null,
  setSession: (session) => set({ session }),
  setUser: (user) => set({ user }),
  setCurrentOrg: (currentOrg) => set({ currentOrg }),
  clear: () => set({ session: null, user: null, currentOrg: null }),
}));